import { RdExpenditureYear } from './rd-expenditure-year.model';

export class IncreaseInRdCalculation {
  detectedFormType: string;
  years: RdExpenditureYear[];

  constructor(taxCreditCalculation?: any) {
    if (taxCreditCalculation) {
      Object.assign(this, taxCreditCalculation);
    }
  }
}
